import React, { Fragment } from 'react';

import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import {
	getMacroAttributesFromADFNode,
	getExperienceName,
} from '@confluence/macro-tracker/entry-points/MacroExperienceTracker.ts';
import { MacroExperienceSuccess } from '@confluence/macro-tracker/entry-points/MacroExperienceSuccess.ts';
import { CreateFromTemplateLoader } from '@confluence/create-from-template/entry-points/CreateFromTemplate.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export const CreateFromTemplate = ({
	...macroDefaultProps
}: ExtensionHandlerProps): React.JSX.Element => {
	const { contentId, extensionKey, node, mode } = macroDefaultProps;
	const attributes = getMacroAttributesFromADFNode(node);

	const { cloudId, userId } = useSessionData();

	return (
		<Fragment>
			<CreateFromTemplateLoader
				userId={userId || ''}
				cloudId={cloudId}
				macroDefaultProps={macroDefaultProps}
			/>
			<MacroExperienceSuccess
				name={getExperienceName(mode, node)}
				contentId={contentId}
				extensionKey={extensionKey}
				mode={mode}
				attributes={attributes}
			/>
		</Fragment>
	);
};
